import { createAction, props } from '@ngrx/store'
import { ReviewRequestCampaignModel, RequestModel, BasicReviewRequestCampaignInfo, LocationModel } from '@models/index'
import {CampaignState} from '@enums/campaingState.enum'


export const searchReviewRequestCampaigns = createAction(
    '[Campaigns Page] Search Review Request Campaigns',
    props<{ request: RequestModel }>()
)

export const searchReviewRequestCampaignsByLocationId = createAction(
    '[Campaigns Page] Search Review Request Campaigns By Location Id',
    props<{ request: RequestModel }>()
)

export const searchReviewRequestCampaignsSuccess = createAction(
    '[Campaigns Page] Search Review Request Campaigns Success',
    props<{ data: ReviewRequestCampaignModel[] }>()
)

export const searchReviewRequestCampaign = createAction(
    '[Campaigns Page] Search Review Request Campaign',
    props<{ request: RequestModel }>()
)

export const searchReviewRequestCampaignSuccess = createAction(
    '[Campaigns Page] Search Review Request Campaign Success',
    props<{ data: ReviewRequestCampaignModel }>()
)

export const saveReviewRequestCampaign = createAction(
    '[Campaigns Page] Save Review Request Campaign',
    props<{ request: RequestModel }>()
)

export const saveReviewRequestCampaignSuccess = createAction(
    '[Campaigns Page] Save Review Request Campaign Success',
    props<{ reviewRequestCampaign: ReviewRequestCampaignModel }>()
)

export const deleteCampaign = createAction(
    '[Campaigns Page] Delete Campaign',
    props<{ request: RequestModel }>()
)

export const deleteCampaignSuccess = createAction(
    '[Campaigns Page] Delete Campaign Success',
    props<{ campaignId: string }>()
)

export const setCampaignState = createAction(
    '[Campaigns Page] Set Campaign State',
    props<{ request: RequestModel }>()
)

export const setCampaignStateSuccess = createAction(
    '[Campaigns Page] Set Campaign State Success',
    props<{ campaignId: string, campaignState: CampaignState, editionState: string }>()
)

export const setSelectedReviewRequestCampaign = createAction(
    '[Campaigns Page] Set Review Request Campaign',
    props<{ reviewRequestCampaign: ReviewRequestCampaignModel }>()
)

export const setSaveSuccesCampaign = createAction(
    '[Campaigns Page] Set Save Campaign',
    props<{ save: boolean }>()
)

export const sendSmsContentTest = createAction(
    '[Campaigns Page] Send Sms Content Test',
    props<{ request: RequestModel }>()
)

export const sendSmsContentTestSuccess = createAction(
    '[Campaigns Page] Send Sms Content Test Success',
    props<{ sendSmsTest: boolean }>()
)

export const sendEmailTest = createAction(
    '[Campaigns Page] Send Email Content Test',
    props<{ request: RequestModel }>()
)

export const sendEmailTestSuccess = createAction(
    '[Campaigns Page] Send Sms Email Test Success',
    props<{ sendEmailTest: boolean }>()
)

export const campaingError = createAction(
    '[Campaigns Page] Campaign Error',
    props<{ error: string }>()
)

export const getLocationCampaignsBasicInfo = createAction(
    '[Campaigns Page] Get Location Campaigns Basic Info',
    props<{ request: RequestModel }>()
)

export const getLocationCampaignsBasicInfoSuccess = createAction(
    '[Campaigns Page] Get Location Campaigns Basic Info Success',
    props<{ campaignsInfo: BasicReviewRequestCampaignInfo[] }>()
)

export const getLocationCampaignsBasicInfoByLocationId = createAction(
    '[Campaigns Page] Get Location Campaigns Basic Info By Location Id',
    props<{ request: RequestModel }>()
)

export const addCampaign = createAction(
    '[Campaigns Page] Add Campaign',
    props<{ request: RequestModel }>()
)

export const addCampaignSuccess = createAction(
    '[Campaigns Page] Add Campaign Success',
    props<{ data: ReviewRequestCampaignModel }>()
)

export const filterCampaign = createAction(
    '[Campaigns Page] Filter Campaign ',
    props<{ request: RequestModel }>()
)

export const changeLocationPreferredCampaign = createAction(
    '[Campaigns Page] Change Location Preferred Campaign',
    props<{ request: RequestModel }>()
)

export const changeLocationPreferredCampaignSuccess = createAction(
    '[Campaigns Page] Change Location Preferred Campaign Success',
    props<{ data: LocationModel }>()
)

export const setSelectedCampaign = createAction(
    '[Campaigns Page] Set Selected Campaign',
    props<{ campaign: ReviewRequestCampaignModel }>()
)

export const getLocationCampaignsBasicInfoReports = createAction(
    '[Campaigns Page] Get Location Campaigns Basic Info Reports',
    props<{ request: RequestModel }>()
)

export const getLocationCampaignsBasicInfoReportsSuccess = createAction(
    '[Campaigns Page] Get Location Campaigns Basic Info Reports Success',
    props<{ campaignsInfo: BasicReviewRequestCampaignInfo[] }>()
)

export const setAddCampaign = createAction(
    '[Campaigns Page] Set Add Campaign',
    props<{ status: boolean }>()
)
